export function formatMoneyFen(fen) {
    if (typeof fen === 'undefined') {
        return '';
    }
    if (typeof fen === 'string') {
        fen = parseFloat(fen);
        if (isNaN(fen)) {
            return '';
        }
    }
    return Math.round(fen) / 100;
}

export function formatDate(date, fmt) {
    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    if (!fmt) {
        fmt = 'yyyy.MM.dd hh:mm:ss';
    }

    if (!date) {
        return null;
    }
    const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return fmt;
}
